export const EXO_SKELETON_PLACEHOLDER = '[EXO_SKELETON_PLACEHOLDER]';
